// @formatter:off

import {PathToMars} from './app/path-to-mars/PathToMars.js';
window.PathToMars = PathToMars;

import {Survey} from './app/survey/Survey.js';
window.Survey = Survey;

import {EDL} from './app/edl/EDL.js';
window.EDL = EDL;

import {BuildYourRover} from './app/build-your-rover/BuildYourRover.js';
window.BuildYourRover = BuildYourRover;

import {BuildYourRoverSecondary} from './app/build-your-rover/BuildYourRoverSecondary.js';
window.BuildYourRoverSecondary = BuildYourRoverSecondary;

import {BuildYourRoverRenderer} from './app/build-your-rover/BuildYourRoverRenderer.js';
window.BuildYourRoverRenderer = BuildYourRoverRenderer;

import {BuildYourTeam} from './app/build-your-team/BuildYourTeam.js';
window.BuildYourTeam = BuildYourTeam;

// @formatter:on

// Debug panels. Scans the app folder for *Debug.js modules and includes them all,
// so a new one is picked up just by adding the file. Each stays inactive until its
// own URL parameter is added, so they cost nothing the rest of the time.
// DEBUG_PANELS is set by webpack, false in release builds (grunt buildjs) so none get bundled.
if (DEBUG_PANELS) {
  const debugModules = require.context("./app", true, /Debug\.js$/);
  debugModules.keys().forEach(debugModules);
}
